import type { ReactNode } from 'react';
import type { PriceBookSheetRowView, PriceBookSubsectionView } from '@/document-render/domain/priceBook/buildPriceBookBySheetView';
import { RATE_TABLE_STYLE, SUBSECTION_LABEL_STYLE, rateHeadCellStyle } from './priceBookSheetStyles';

/** One subsection (Equipment / Labor / Material / Additional) of a rate sheet. */
export function PriceBookRateTable({
  subsection,
  renderRow,
  headerFontSize
}: {
  subsection: PriceBookSubsectionView;
  renderRow: (row: PriceBookSheetRowView) => ReactNode;
  headerFontSize?: number | string;
}) {
  return (
    <div data-price-book-subsection={subsection.key}>
      <div style={SUBSECTION_LABEL_STYLE}>{subsection.label}</div>
      <table style={RATE_TABLE_STYLE}>
        <thead>
          <tr>
            {subsection.columns.map((column) => (
              <th key={column.key} scope="col" style={rateHeadCellStyle(column.align, headerFontSize)}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{subsection.rows.map(renderRow)}</tbody>
      </table>
    </div>
  );
}
